import { useCallback, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../store/configureStore';
import { ApiRequestStatus } from '../enums/apiRequestStatus';
import { getPersonalDetailsAsync } from '../slices/personSlice';
import { useCurrentUser } from '../auth/useCurrentUser';

export const useGetPersonalDetails = () => {
    const { personId } = useCurrentUser();
    const dispatch = useAppDispatch();
    const { personalDetailsPersonId, personalDetailsStatus, personalDetailsError } = useAppSelector(state => state.personalDetail);
    const retry = useCallback(() => {
        if (personId) return dispatch(getPersonalDetailsAsync(personId));
    }, [dispatch, personId]);

    useEffect(() => {
        if (personId && (personalDetailsPersonId !== personId || personalDetailsStatus === ApiRequestStatus.Idle)) retry();
    }, [personId, personalDetailsPersonId, personalDetailsStatus, retry]);

    return { personalDetailsStatus, personalDetailsError, retry };
};
